"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _uniformsBridgeJsonSchema = require("uniforms-bridge-json-schema");

var _default = function _default(_ref) {
  var i18n = _ref.i18n,
      createValidator = _ref.createValidator;
  var schema = {
    title: 'Login',
    type: 'object',
    properties: {
      email: {
        type: 'string',
        format: 'email',
        minLength: 1,
        label: i18n.t('E-mail')
      },
      password: {
        type: 'string',
        minLength: 1,
        label: i18n.t('Password'),
        uniforms: {
          type: 'password'
        }
      }
    },
    required: ['email', 'password']
  };
  var schemaValidator = createValidator(schema);
  var bridge = new _uniformsBridgeJsonSchema.JSONSchemaBridge(schema, schemaValidator);
  return bridge;
};

exports.default = _default;